import { render, staticRenderFns } from "./PolarTest.vue?vue&type=template&id=5b16d1c1&"
import script from "./PolarTest.vue?vue&type=script&lang=js&"
export * from "./PolarTest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports